import { Outlet } from "react-router-dom"

const LightParametersComponent = () => {
    return <Outlet />
}

export default LightParametersComponent;